<template>
  <div
    class="d-flex position-relative cursor-pointer"
    data-testid="searchbar-team-item"
    @mousedown="onCardClick()"
  >
    <v-container fluid v-if="team" class="px-1 pb-1 pt-1">
      <v-row>
        <v-col cols="2" class="px-3 py-0 d-flex justify-center align-center">
          <img
            :src="
              'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' + team.id + '.png'
            "
            :height="28"
            contain
            @error="onImageLoadFailure($event)"
          />
        </v-col>
        <v-col
          cols="10"
          class="pl-2 pr-0 py-0 d-flex flex-column justify-center"
        >
          <div class="d-flex flex-column">
            <div class="d-flex align-center justify-space-between">
              <div class="d-flex flex-grow-1">
                <span class="body-2 primary--text">{{
                  team.name
                }}</span>
              </div>
              <div
                class="d-flex"
                v-if="team.ranking && !$vuetify.breakpoint.smAndDown"
              >
                <small class="font-weight-bold primary--text mx-2"
                  >#{{ team.ranking }}</small
                >
              </div>
            </div>
            <div
              class="d-flex align-center justify-space-between mt-n2"
              v-if="!$vuetify.breakpoint.smAndDown"
            >
              <small class="font-weight-light primary--text text-ellipsis" style="max-width:135px;">{{
                team.coachName
              }}</small>
              <div class="my-1 d-flex align-center">
                <DriblabCountryFlag :iso="team.cC"></DriblabCountryFlag>
                <div class="mx-2 body-2 text-ellipsis primary--text">
                  {{ team.lName }}
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DriblabCountryFlag from '../base/DriblabCountryFlag';

export default {
  name: "TeamSearchItem",
  components: {
    DriblabCountryFlag
  },
  created() {},
  props: {
    team: {
      type: Object,
      default: false,
    },
    allowRouter: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onCardClick() {
      if (this.allowRouter) {
        this.$router.push({ name: "team", params: { id: this.team.id } });
      }
    },
    onImageLoadFailure(event) {
      event.target.src = "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png";
    },
  },
};
</script>
